const Picture = {
  el: {
    root: document.querySelectorAll('.picture'),
  },

  init() {
    if (this.el.root) {
      this.el.root.forEach((target) => {

        const picture = target
        const image: HTMLImageElement = target.querySelector('.picture__image')
        const imageSrc = image.getAttribute('src')
        let imageLoaded = false

        if (image) {
          if (image.complete) {
            picture.classList.add('picture--loaded')
          } else {
            Picture.observeImage(image, picture, imageSrc, imageLoaded)
          }
        }
      })
    }
  },

  observeImage: (image, picture, imageSrc, imageLoaded) => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !imageLoaded) {
            const loadingImage = new Image()
            loadingImage.onload = () => {
              image.src = loadingImage.src
              picture.classList.add('picture--loaded')
              imageLoaded = true
            }

            loadingImage.src = imageSrc
          }
        })
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      }
    )

    observer.observe(image)
  },
}

export default Picture